// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvv47k{padding-left:var(--ds-space-250,20px)}\n._bozgv47k{padding-inline-start:var(--ds-space-250,20px)}", ""]);
// Exports
module.exports = exports;
